module.exports = __webpack_public_path__ + "static/media/fulfilment-storage-header.d0631a6d.png";